<template>
  <div>
    <div v-if="isCounting" class="authentication-resend-wait">
      Você poderá reenviar o código em <span>{{ formattedTime }}</span>
    </div>

    <div v-else class="authentication-resend">
      Não recebeu o código?
      <slot name="resend"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 60
    }
  },

  data() {
    return {
      secondsRemaining: this.duration,
      interval: null
    }
  },

  computed: {
    isCounting() {
      return this.secondsRemaining > 0
    },

    formattedTime() {
      const minutes = Math.floor(this.secondsRemaining / 60)
      const seconds = this.secondsRemaining % 60

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    }
  },

  mounted() {
    this.interval = window.setInterval(() => {
      if (this.secondsRemaining <= 0) {
        this.clearCountdown()
        return
      }

      this.secondsRemaining -= 1
    }, 1000)
  },

  beforeDestroy() {
    this.clearCountdown()
  },

  methods: {
    twoDigits(number) {
      return number < 10 ? `0${number}` : String(number)
    },

    clearCountdown() {
      if (!this.interval) return

      window.clearInterval(this.interval)
      this.interval = null
    }
  }
}
</script>
